import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useContext, useState } from 'react';
import { Box, Copy } from '@honda-canada/design-system-react';
import { UserLocationContext } from '@honda-canada/user-location';
import { useTranslation } from 'react-i18next';
import UserLocationModal from '../../UserLocationModal';
import GeoLocatorSummary from './GeoLocatorSummary';
import isSSR from '../../../utils/isSSR';
import themeStyles from '../styles/LoyaltyOfferFilters.styles';
const Container = themeStyles.apply(Box, 'GeoLocatorContainer');
const GeoLocator = () => {
    const { t } = useTranslation();
    const [isUserLocationModalOpen, setIsUserLocationModalOpen] = useState(false);
    const userLocation = useContext(UserLocationContext);
    if (isSSR())
        return _jsx(Container, {});
    return (
    // DO NOT REMOVE empty Fragment. It is required to fix breaking UI bug in jss app
    // eslint-disable-next-line react/jsx-no-useless-fragment
    _jsxs(_Fragment, { children: [_jsx(Copy, { "data-testid": "cy-loyalty-offers-filter_geolocator-label", fontFamily: "bold", size: "extraSmall", children: t('Shared.Common.offersAvailableLabel') }), _jsxs(Container, { "data-testid": "cy-loyalty-offers-filter_geolocator-summary-wrapper", children: [_jsx(GeoLocatorSummary, { addressSelectedByUser: false, onChangeLocationClick: value => setIsUserLocationModalOpen(value), ...userLocation }), _jsx(UserLocationModal, { allowClose: true, id: "cy-loyalty-offers-filter_geolocator-modal", isOpen: isUserLocationModalOpen, setIsUserLocationModalOpen: setIsUserLocationModalOpen, onLocationDetected: () => setIsUserLocationModalOpen(false), onSubmitLocation: undefined, bodyTextLinkStyling: undefined })] })] }));
};
export default GeoLocator;
